import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './Pagination.css';

/**
 * Pagination Component
 * @param {number}   currentPage
 * @param {number}   totalPages
 * @param {function} onPageChange
 * @param {number}   siblingCount  - pages shown on each side of current
 */
const Pagination = ({ currentPage, totalPages, onPageChange, siblingCount = 1 }) => {
  if (totalPages <= 1) return null;

  const range = (start, end) =>
    Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const buildPages = () => {
    const total = totalPages;
    const current = currentPage;
    const DOTS = '...';

    const leftSib  = Math.max(current - siblingCount, 1);
    const rightSib = Math.min(current + siblingCount, total);

    const showLeft  = leftSib > 2;
    const showRight = rightSib < total - 1;

    if (!showLeft && !showRight) return range(1, total);
    if (!showLeft) return [...range(1, rightSib), DOTS, total];
    if (!showRight) return [1, DOTS, ...range(leftSib, total)];
    return [1, DOTS, ...range(leftSib, rightSib), DOTS, total];
  };

  const pages = buildPages();

  return (
    <nav className="pagination" aria-label="Pagination">
      <button
        className="pagination__btn pagination__btn--nav"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <FiChevronLeft />
      </button>

      {pages.map((page, idx) =>
        page === '...' ? (
          <span key={`dots-${idx}`} className="pagination__dots">…</span>
        ) : (
          <button
            key={page}
            className={`pagination__btn ${page === currentPage ? 'pagination__btn--active' : ''}`}
            onClick={() => onPageChange(page)}
            aria-label={`Page ${page}`}
            aria-current={page === currentPage ? 'page' : undefined}
          >
            {page}
          </button>
        )
      )}

      <button
        className="pagination__btn pagination__btn--nav"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        <FiChevronRight />
      </button>
    </nav>
  );
};

export default Pagination;
